angular.module('core')
  .service('dblAcademicMappingStringCustomizerService', ['translateFilter', function (translateFilter) {
      var _templates = {};
      _init();
      return {
          render: render
      };

      function _init() {
          _templates = {
              cflm: {
                  'cflm test': _.template(translateFilter('academicMappingStringCustomizer.clfmTest')),
                  'SEARCH FOR A GRADE': _.template(translateFilter('academicMappingStringCustomizer.searchForADomain')),
                  'SELECT A GRADE': _.template(translateFilter('academicMappingStringCustomizer.selectADomain'))
              },

              PROGRAM: {
                  'PROFICIENT IN': _.template(translateFilter('academicMappingStringCustomizer.focusCompleted')),
                  'STANDARD MET': _.template(translateFilter('academicMappingStringCustomizer.allLessonsComplete')),
                  'IN ALL AVAILABLE STANDARDS': _.template(translateFilter('academicMappingStringCustomizer.allLessonsComplete'))
              },

              STANDARD: {
                  'PROFICIENT IN': _.template(translateFilter('academicMappingStringCustomizer.proficientInFocus')),
                  'STANDARD MET': _.template(translateFilter('academicMappingStringCustomizer.focusMet')),
                  'IN ALL AVAILABLE STANDARDS': _.template(translateFilter('academicMappingStringCustomizer.inAllAvailableStandardsInFocus')),
                  'IN ALL AVAILABLE OBJECTIVES': _.template(translateFilter('academicMappingStringCustomizer.inAllAvailableObjectivesInFocus'))
              },

              _defaults: {
                  'default test': _.template(translateFilter('academicMappingStringCustomizer.defaultTest')),
                  'PROFICIENT IN': _.template(translateFilter('academicMappingStringCustomizer.proficient')),
                  'STANDARD MET': _.template(translateFilter('academicMappingStringCustomizer.standardMet')),
                  'IN ALL AVAILABLE STANDARDS': _.template(translateFilter('academicMappingStringCustomizer.inAllAvailableStandards')),
                  'SEARCH FOR A GRADE': _.template(translateFilter('academicMappingStringCustomizer.searchForAGrade')),
                  'SELECT A GRADE': _.template(translateFilter('academicMappingStringCustomizer.selectAGrade'))
              }
          };
      }

      function _getAcademicMappingTemplates(mappingName) {
          return _templates[mappingName];
      }

      function _getTemplateNoDefault(mappingName, stringName) {
          var amStrings = _getAcademicMappingTemplates(mappingName);
          if (!amStrings) {
              return null;
          }

          return amStrings[stringName];
      }

      function _getTemplateWithDefault(mappingName, stringName) {
          var template;

          template = _getTemplateNoDefault(mappingName, stringName);
          if (!template) {
              template = _getTemplateNoDefault('_defaults', stringName);
          }
          return template;
      }

      function _expand(template, params) {
          return template(params);
      }

      function render(mappingName, stringName, params) {
          var template = _getTemplateWithDefault(mappingName, stringName);
          if (template) {
              return _expand(template, params);
          } else {
              return "ERROR NO STRING[" + mappingName + ':' + stringName + "]";
          }
      }
  }]);
